import React from "react";
import { Link } from "react-router-dom";

import "./styles.css";

export default function ListLink({ title, href }) {
  let target = "_blank";
  let rel = "noopener noreferrer";

  if (href.includes("crefito2.gov.br")) {
    href = href.split("crefito2.gov.br").pop();
    target = "";
    rel = "";
  }

  return (
    <Link className="list-link" to={href} target={target} rel={rel}>
      <p
        className="list-link__title"
        dangerouslySetInnerHTML={{ __html: title }}
      ></p>
    </Link>
  );
}
